import { get } from 'lodash'
import moment from 'moment'

export default {
  prepareShow (schedule) {
    schedule.company = ''
    schedule.covenant = get(schedule, 'covenant.name', null)
    schedule.patient = get(schedule, 'patient.name', null)
    schedule.time = moment(schedule.date).format('HH:mm')
    schedule.date = moment(schedule.date).format('DD/MM')

    return schedule
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/next-patient/resources/methods.js